var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md logo"},[_c('router-link',{style:('background-image: url('+ _vm.getLOGOpath +')'),attrs:{"to":{path: '/index'},"expect":""}},[_vm._v(_vm._s(_vm.$t('site.noun.sitename')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }